const INITIAL_STATE = {
	aguardando: false,
	registro: [],
	modoTela: 'lista',
	lista: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'REPORTS_INTEGRACAO_VOLVO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'REPORTS_INTEGRACAO_VOLVO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'REPORTS_INTEGRACAO_VOLVO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        default:
            return state;
    }
}
